import { createGqlClient } from "@insightfulscience/shared-utils/gqlClient";
import {
	batch,
	context,
	tap,
} from "@insightfulscience/shared-utils/gqlClient/middlewares";

const pureGqlClient = ({
	publicConfig: { GRAPHQL_URI },
	gqlEventsListener,
	globalContext,
}) =>
	createGqlClient(
		{ uri: GRAPHQL_URI },
		tap(gqlEventsListener),
		batch(),
		context((ctx) => ({
			...ctx,
			headers: {
				...ctx.headers,
				"x-request-id":
					globalContext?.req?.requestId ?? Math.random().toFixed(20).slice(2),
			},
		})),
	);

export default pureGqlClient;
